import httpClient from '@utils/httpClient.js';

export function updateSpacerApiCall(options) {
  const { id, height, view = '1' } = options;

  const profileId = localStorage.getItem('unilinkProfileId');

  return httpClient.put(`api/profiles/${profileId}/email-marketing/block/spacer`, {
    id,
    height,
    view,
  });
}
